// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"SuitesComparisonModal_modal-body__MjpET","modalBody":"SuitesComparisonModal_modal-body__MjpET","extended":"SuitesComparisonModal_extended__F0Iys"};